import { SpecialOrganizationId } from '@upright/common/iam/organizations/organization-types';

/**
 * The organization a team user's selector opens on when neither the URL nor the route names one.
 *
 * The team default is a platform setting managed at `/internal/team-default-organization`. It is
 * only honoured when it is among `organizations`, the orgs the selector lists, so an org that has
 * since changed to a type the selector hides falls back to Upright instead of leaving the home view
 * with nothing to render against. Expects a non-empty list, as the selector's caller guarantees.
 */
export function pickTeamDefaultOrganization<T extends { id: number }>(
  organizations: T[],
  teamDefaultOrganizationId: number | null | undefined,
): T {
  return (
    organizations.find(org => org.id === teamDefaultOrganizationId) ??
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    organizations.find(org => org.id === SpecialOrganizationId.UPRIGHT) ??
    organizations[0]
  );
}
